class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);


    // TODO: fix hardcoded free bracelet adding. Issue: cart is not initiated until the cart is clicked. 

    // const cartItems = document.querySelector('.mini-cart');
    // console.log(cartItems);
    // let free_gift_id = cartItems.dataset.freeGiftId;


    // let gift_added = false;

    // fetch(window.Shopify.routes.root + 'cart.js', {
    //   method: 'GET',
    //   headers: {
    //     'Content-Type': 'application/json'
    //   }
    // })
    // .then(response => {
    //   return response.json();
    // })
    // .then(function(data) {
    //   var cart_items = data.items;
    //   cart_items.forEach((item) => {
    //     if (item.id == 39658512580682) {
    //       gift_added = true;
    //       return;
    //     }
    //   });
    // })
    // .then(function(){
    //   if (gift_added == false) {
    //     let formData = {
    //       'items': [{
    //       'id': 39658512580682,
    //       'quantity': 1
    //       }]
    //     };
    //     fetch(window.Shopify.routes.root + 'cart/add.js', {
    //       method: 'POST',
    //       headers: {
    //         'Content-Type': 'application/json'
    //       },
    //       body: JSON.stringify(formData)
    //     })
    //     .then(response => {
    //       return response.json();
    //     })
    //     .catch((error) => {
    //       console.error('Error:', error);
    //     });
    //   }
    // })
    // .catch((error) => {
    //   console.error('Error:', error);
    // });
    
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);
